<template>
    <section class="f fh el-details-list">
        <div class="u-us-n te-link te-fat-section sp-t-s sp-b-m sp-l-l sp-r-l"
            v-for="el in tabs"
            :key="el.key"
            @click="onItemSelected(el.key)"
            :class="[selection === el.key ? 'el--active' : '', el.class || '']">
            <!-- Content of each tab, given {tab, active}; defaults to the translated label -->
            <slot name="tab" :tab="el" :active="selection === el.key">
                <span>{{ el.lbl | athT }}</span>
            </slot>
        </div>
    </section>
</template>
<script>
export default {
    name: 'mead-basic-tab-display',
    props: {
        /**
         * Array of tabs to display, each shaped as `{key, lbl, class}` where `key` uniquely
         * identifies the tab for selection, `lbl` is the display label (run through the `athT`
         * translation filter), and `class` is an optional extra class applied to the tab element.
         */
        tabs: {type: Array, required: true},
        /**
         * Key of the tab that should be preselected. Can be left blank, in which case the first
         * tab in `tabs` is selected by default.
         */
        selected: {type: String, default: ''},
    },
    data: function () {
        return {
            selection: this.selected.length > 0 ? this.selected : this.tabs[0].key
        };
    },
    methods: {
        onItemSelected: function (key) {
            this.selection = key;
            this.$emit('onSelection', this.selection);
        }
    }
};
</script>
<style lang="scss" scoped>
.el-details-list {
    .te-link {
        cursor: pointer;
        text-decoration: none;

        &:hover,
        &.el--active {
            color: var(--c-brand-main);
        }

        &.el--active {
            box-shadow: inset 0 -2px 0 0 var(--c-brand-main);
        }
    }
}
</style>